<template>
  <nav
    class="gx-nav"
    :class="{ 'gx-nav--solid': scrolled, 'gx-nav--compact-auth': compactAuth }"
  >
    <button class="gx-nav__brand" @click="$emit('home')">
      <img class="gx-nav__logo" src="https://xinghaohuo.oss-cn-beijing.aliyuncs.com/logo.jpg" alt="观星树 Logo">
      <span class="gx-nav__brand-text">
        <span class="gx-nav__name">观星树</span>
        <span class="gx-nav__sub">STAR · TREE</span>
      </span>
    </button>

    <div class="gx-nav__links">
      <button
        v-for="link in links"
        :key="link.id"
        class="gx-nav__link"
        :class="{ 'gx-nav__link--active': active === link.id }"
        @click="link.fn"
        @mouseenter="hover = link.id"
        @mouseleave="hover = ''"
      >
        {{ link.label }}
      </button>
    </div>

    <div class="gx-nav__right">
      <template v-if="isLoggedIn">
        <button class="gx-nav__enter" @click="$emit('enter')">
          进入工作台
        </button>
      </template>
      <template v-else>
        <button class="gx-nav__ghost" @click="$emit('login')">登录</button>
        <button class="gx-nav__primary" @click="$emit('register')">
          {{registerLabel}}
        </button>
      </template>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NewUiNav",
  props: {
    active: { type: String, default: "" },
    isLoggedIn: { type: Boolean, default: false },
    registerLabel: { type: String, default: "注册" },
    compactAuth: { type: Boolean, default: false },
  },
  data() {
    return {
      scrolled: false,
      hover: "",
      links: [],
    };
  },
  mounted() {
    this.buildLinks();
    const fn = () => {
      this.scrolled = window.scrollY > 60;
    };
    window.addEventListener("scroll", fn, { passive: true });
    this._fn = fn;
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this._fn);
  },
  methods: {
    buildLinks() {
      const items = [];
      if (this.$listeners.member) {
        items.push({
          id: "member",
          label: "会员权益",
          fn: () => this.$emit("member"),
        });
      }
      if (this.$listeners.about) {
        items.push({
          id: "about",
          label: "关于我们",
          fn: () => this.$emit("about"),
        });
      }
      this.links = items;
    },
  },
};
</script>

<style scoped>
.gx-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 52px;
  background: transparent;
  border-bottom: 1px solid transparent;
  transition: all var(--gx-member-motion-base, 0.5s) var(--gx-member-ease, cubic-bezier(0.22, 1, 0.36, 1));
}
.gx-nav--solid {
  background: var(--gx-member-nav-bg, rgba(7, 14, 34, .94));
  backdrop-filter: blur(28px);
  -webkit-backdrop-filter: blur(28px);
  border-bottom: 1px solid var(--gx-member-accent-line, rgba(212, 169, 70, .16));
}
.gx-nav__brand {
  display: flex;
  align-items: center;
  gap: 11px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
.gx-nav__logo {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: block;
  object-fit: contain;
  box-shadow: 0 0 20px rgba(212, 169, 70, 0.5);
  flex-shrink: 0;
  animation: gx-treeBreathe 4s var(--gx-member-ease, ease-in-out) infinite;
}
.gx-nav__brand-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.gx-nav__name {
  font-family: var(--gx-member-font-display, "Noto Serif SC", serif);
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.05em;
  line-height: 1;
  background: linear-gradient(135deg, var(--gx-member-text, #f0ebe0), var(--gx-member-accent, #d4a946));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.gx-nav__sub {
  font-family: var(--gx-member-font-mono, Inter, monospace);
  font-size: 8px;
  color: var(--gx-member-accent-muted, rgba(212, 169, 70, .55));
  letter-spacing: 3px;
  line-height: 1;
  margin-top: 1px;
}
.gx-nav__links {
  display: flex;
  gap: 40px;
}
.gx-nav__link {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 0;
  font-family: var(--gx-member-font-sans, "Noto Sans SC", sans-serif);
  font-size: 14px;
  color: var(--gx-member-nav-text, rgba(240, 235, 224, .55));
  position: relative;
  transition: color var(--gx-member-motion-base, 0.5s) var(--gx-member-ease, cubic-bezier(0.22, 1, 0.36, 1));
}
.gx-nav__link:hover,
.gx-nav__link--active {
  color: var(--gx-member-accent, #d4a946);
}
.gx-nav__link::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 1.5px;
  border-radius: 1px;
  background: var(--gx-member-accent, #d4a946);
  transition: width var(--gx-member-motion-base, 0.5s) var(--gx-member-ease, cubic-bezier(0.22, 1, 0.36, 1));
  width: 0;
}
.gx-nav__link:hover::after,
.gx-nav__link--active::after {
  width: 100%;
}
.gx-nav__right {
  display: flex;
  gap: 10px;
  align-items: center;
}
.gx-nav__ghost {
  height: 38px;
  padding: 0 20px;
  border-radius: 10px;
  cursor: pointer;
  background: transparent;
  border: 1px solid var(--gx-member-accent-border, rgba(212, 169, 70, .45));
  font-family: var(--gx-member-font-sans, "Noto Sans SC", sans-serif);
  font-size: 14px;
  color: var(--gx-member-accent, #d4a946);
  transition: all var(--gx-member-motion-base, 0.5s) var(--gx-member-ease, cubic-bezier(0.22, 1, 0.36, 1));
}
.gx-nav__ghost:hover {
  background: var(--gx-member-accent-soft, rgba(212, 169, 70, .12));
}
.gx-nav__primary {
  height: 38px;
  padding: 0 22px;
  border-radius: 10px;
  cursor: pointer;
  background: linear-gradient(135deg, var(--gx-member-accent, #d4a946), var(--gx-member-accent-light, #f0c44a));
  border: none;
  font-family: var(--gx-member-font-sans, "Noto Sans SC", sans-serif);
  font-size: 14px;
  font-weight: 600;
  color: var(--gx-member-on-accent, #071025);
  box-shadow: 0 4px 18px rgba(212, 169, 70, 0.42);
  transition: all var(--gx-member-motion-base, 0.5s) var(--gx-member-ease, cubic-bezier(0.22, 1, 0.36, 1));
}
.gx-nav__primary:hover {
  filter: brightness(1.12);
  transform: scale(1.04);
}
.gx-nav__enter {
  height: 38px;
  padding: 0 26px;
  border-radius: 10px;
  cursor: pointer;
  background: linear-gradient(135deg, var(--gx-member-accent, #d4a946), var(--gx-member-accent-light, #f0c44a));
  border: none;
  font-family: var(--gx-member-font-sans, "Noto Sans SC", sans-serif);
  font-size: 14px;
  font-weight: 700;
  color: var(--gx-member-on-accent, #071025);
  box-shadow: 0 4px 20px rgba(212, 169, 70, 0.45);
  transition: all var(--gx-member-motion-base, 0.5s) var(--gx-member-ease, cubic-bezier(0.22, 1, 0.36, 1));
}
.gx-nav__enter:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 32px rgba(212, 169, 70, 0.7);
}
.gx-nav--compact-auth .gx-nav__ghost,
.gx-nav--compact-auth .gx-nav__primary {
  padding: 0 17px;
}
@media (max-width: 900px) {
  .gx-nav {
    padding: 0 20px;
  }
  .gx-nav__links {
    display: none;
  }
}
</style>
